import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFilterModal from "../../components/Common/CommonFilterModal";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination/index";
import NavBarTitles from "../../components/Common/TabBar";
import { fee } from "../../components/Constants";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import LeadStatusConfirm from "../../components/Modal/LeadStatusConfirm";
import SucessModal from "../../components/Modal/SucessModal";
import ExcelDownload from "../../components/Utils/excelDownload";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import useSortHandler from "../../components/Utils/hooks/useSortHandler";
import {
  DoctorRegistrationcolumnOrder,
  DoctorRegistrationTable,
  HealthSynergynavBarData,
  PartneredDoctors,
} from "./HealthSynergyConst";
import "./healthsy.scss";

const emptyFilterValues = {
  Fee: [],
  Gender: [],
  Language: [],
  "City / Town": [],
  "Primary Specialisation": [],
  "Lead Status": [],
  BD: [],
};

const DoctorRegistration = () => {
  // Sorting
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");
  const handleSortClick = useSortHandler(setSort, setSortName);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  // Filters
  const [gender, setGender] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [primarySpl, setPrimarySpl] = useState([]);
  const [bdModal, setBdModal] = useState([]);
  const [language, setLanguage] = useState([]);
  const [selectedValues, setSelectedValues] = useState(emptyFilterValues);
  const [selectedCategory, setSelectedCategory] = useState("Fee");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [tempSelectedValues, setTempSelectedValues] =
    useState(emptyFilterValues);

  // Delete
  const [showDelete, setShowDelete] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [loader, setLoader] = useState(true);
  const [leadStatusConfirmModal, setLeadStatusConfirmModal] = useState({
    leadType: "",
    status: false,
    id: "",
  });
  const [deleteId, setDeleteId] = useState("");

  // Pagination
  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}doctor-registration/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  useEffect(() => {
    !assignModal.status && !leadStatusModal.status && setLoader(true);
    fetchData();
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    selectedValues,
    success,
    leadStatussuccess,
  ]);

  const handleDelete = useDeleteHandler(
    "doctor-registration",
    fetchData,
    setShowDelete
  );

  const handlePageChange = usePageChange(pagination, setPagination);

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
  };
  const fetchAndMap = async (url, mapFn) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}${url}`,
        { noLimit: true }
      );
      return data?.rows?.map(mapFn) || [];
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
      return [];
    }
  };
  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  useEffect(() => {
    const fetchData = async () => {
      const [genders, leadStatuses, bdModals, primarySpls, languages] =
        await Promise.all([
          fetchAndMap("gender/list", (gender) => gender?.type),
          fetchAndMap("lead-status/list", (lead) => lead?.type),
          fetchAndMap("bd/list", (data) => data?.bd_name),
          fetchAndMap("primary-specialisation/list", (data) => data?.type),
          fetchAndMap("languages/list", (data) => data?.type),
        ]);
      setGender(genders);
      setLeadStatus(leadStatuses);
      setBdModal(bdModals);
      setPrimarySpl(primarySpls);
      setLanguage(languages);
    };

    fetchData();
  }, []);

  const filters = useMemo(
    () => ({
      Fee: fee,
      Gender: gender,
      Language: language,
      "City / Town": [],
      "Primary Specialisation": primarySpl,
      "Lead Status": leadStatus,
      BD: bdModal,
    }),
    [gender, leadStatus, bdModal, primarySpl, language]
  );

  const onClickDownload = async () => {
    try {
      const formattedRecords = records.map((record, index) => ({
        "S.No": index + 1,
        "Time of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleTimeString()
          : "",
        "Date of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleDateString()
          : "",
        "Name of the Doctor": record.name || "",
        "Contact Number": record.mobile || "",
        "Email ID": record.email || "",
        Degree: record.degree || "",
        "PG Degree": record.qualification || "",
        "Other Certified Education": record.education || "",
        Gender: record.gender || "",
        "Primary Specialisation": record.specialization || "",
        "MCI / SMC Number": record.mci || "",
        "Year of Registration with Medical Council":
          record.registered_year || "",
        "Council Type": record.council_type || "",
        "State Medical Council": record.medical_council || "",
        "Awards & Recognition": record.awards_recognition || "",
        Organisation: record.organisation.join(", ") || "",
        Fellowship: record.fellowship || "",
        "Mode of Consultation": record.intrested_mode || "",
        Memberships: record.memberships || "",
        "About Yourself": record.about || "",
        "Online Fee": record.online_consultation_fee || "",
        "In-Clinic Fee": record.in_clinic_fee || "",
        "Primary Language": record.languages_known[0] || "",
        "Other Language Known":
          record.languages_known.slice(1).join(", ") || "",
        State: record.state || "",
        City: record.city || "",
        Location: record.location || "",
        Pincode: record.pincode || "",
        "Clinic Name": record.clinic_name || "",
        "Clinic Address": record.clinic_address || "",
        // "Clinic Contact Number": record.clinic_contact_number || "",
        "PoC Name": "",
        "PoC Number": "",
        "Clinic Name - 2": record.clinic_name_2 || "",
        "Clinic Address - 2": record.clinic_address_2 || "",
        "Clinic Contact Number - 2": record.clinic_contact_number_2 || "",
        // "Clinic Name - 3": "",
        "Clinic Address - 3": "",
        // "Clinic Contact Number - 3": "",
        "Are you currently using telemedicine platform":
          record.telemedicine || "",
        "Establishment Details": record.establishment || "",
        "BD Name": "",
        "App Download Android Click": record.android_click || 0,
        "App Download iOS Click": record.ios_click || 0,
        "Brochure Icon Click Status (1.0)": record.brochure_click || 0,
        "Assigned To": record.assigned_to || "",
        "Lead Status": record.lead_status || "",
        // Actions: "",
      }));

      ExcelDownload(
        formattedRecords,
        DoctorRegistrationcolumnOrder,
        "doctor-registrations.xlsx"
      );
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message
      );
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={PartneredDoctors}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total Partnered Doctors : {totalCount}
            </div>
            {totalCount > pagination.limit && (
              <Pagination
                skip={pagination.skip}
                limit={pagination.limit}
                total={totalCount}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={HealthSynergynavBarData} />
          <DoctorsFilterOptions
            limit={pagination.limit}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            // setSortShow={setSortShow}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={true}
            onClickDownload={() => setIsModalOpen(true)}
            handleSortClick={handleSortClick}
          />
          <DoctorRegistrationTable
            records={records}
            skip={pagination.skip}
            setAssignModal={setAssignModal}
            setLeadStatusModal={setLeadStatusModal}
            setDeleteId={setDeleteId}
            setShowDelete={setShowDelete}
            // fetchData={fetchData}
            loader={loader}
          />
        </div>
      </MainconternLayout>

      {showDelete && (
        <Deletepopup
          handleDelete={handleDelete}
          id={deleteId}
          handleClose={() => setShowDelete(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
        onApply={async () => {
          await setSelectedValues(tempSelectedValues);
          await setIsFilterModalVisible(false);
          await setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
        }}
        onReset={() => {
          setSelectedValues(emptyFilterValues);
          setTempSelectedValues(emptyFilterValues);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        filters={filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={tempSelectedValues}
        setSelectedValues={setTempSelectedValues}
      />

      {assignModal.status && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
          pathName="doctor-registration"
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          onClick={() => successModalClose()}
          page="/doctor-registration"
        />
      )}

      {leadStatusModal.status && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
        />
      )}

      {leadStatusConfirmModal.status && (
        <LeadStatusConfirm
          id={leadStatusConfirmModal?.leadType}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          leadStatusConfirmModal={leadStatusConfirmModal}
          formType="doctor-registration"
        />
      )}

      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={() => successModalClose()}
          page="/doctor-registration"
        />
      )}

      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default DoctorRegistration;
